import React, { useState, useEffect, useRef } from "react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  ButtonGroup,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import Select from "react-select";
import moment from "moment";

import Axios from "axios";
import { urlAPI, getUser, getToken } from "utility/Common";
import { useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import * as Icons from "react-feather";
import Center from "react-center";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";
import "assets/scss/plugins/forms/flatpickr/flatpickr.scss";
import { useHistory } from "react-router-dom";
import { handleActionLogout } from "redux/actions/auth/logoutActions";
import NumberFormat from "react-number-format";
import ReactExport from "react-export-excel";

// const initFilter = {
//   kodeunit: null,
//   fromdate: moment().format("YYYY-MM-DD"),
//   untildate: moment().format("YYYY-MM-DD"),
// };

const initFilter = {
  sbu: null,
  // kodeunit: null,
  fromdate: moment().format("YYYY-MM-DD"),
  untildate: moment().format("YYYY-MM-DD"),
  //   periode: moment().format("YYYY-MM"),
  //   golongan: null,
};

export default function Index(props) {
  const dispatch = useDispatch();
  const [filter, setFilter] = useState(initFilter);
  const [tableState, setTableState] = useState([]);

  const [tableOps, setTableOps] = useState({
    page: 1,
    limit: 10,
  });

  const [selectSBU] = useState([
    { value: "RSPG", label: "Rumah Sakit Petrokimia Gresik" },
    { value: "GRAHU", label: "Rumah Sakit Grha Husada" },
    { value: "KALIMANTAN", label: "Klinik Satelit Kalimantan" },
    { value: "PPK1", label: "Klinik PPK I PT Petrokimia Gresik" },
    { value: "DRIYO", label: "Rumah Sakit Petrokimia Gresik Driyorejo" },
    { value: "WA", label: "Klinik PPK I Wringinanom Gresik" },
  ]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [showFilter, setShowFilter] = useState(true);

  const [loadingExcel, setLoadingExcel] = useState(false);
  const [dataExcel, setDataExcel] = useState({
    rows: [],
    count: 0,
  });

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  const [openEditor, setOpenEditor] = useState(false);

  useEffect(() => {
    setLoadingTable(true);
    fetchDataTable();
    // fetchSelectorFarmasi();
  }, [tableOps]);

  const fetchDataExcel = async () => {
    if (!loadingExcel) {
      setLoadingExcel(true);
      await Axios.get(
        urlAPI +
          "/v1/obat/excelDataObatKronis?params=" +
          JSON.stringify({
            sbu: filter?.sbu,
            fromdate:
              filter?.fromdate !== null &&
              filter?.fromdate !== "" &&
              filter?.fromdate !== undefined
                ? moment(filter?.fromdate).format("YYYY-MM-DD")
                : null,
            untildate:
              filter?.untildate !== null &&
              filter?.untildate !== "" &&
              filter?.untildate !== undefined
                ? moment(filter?.untildate).format("YYYY-MM-DD")
                : null,
          }),
        {
          headers: {
            Authorization: "Bearer " + getToken(),
          },
        }
      )
        .then((response) => {
          console.log(response);
          if (response?.data?.result?.rows.length > 0) {
            setDataExcel({ ...response?.data?.result });
            setLoadingExcel(false);
          } else {
            setLoadingExcel(false);
            setDataExcel({ rows: [], count: 0 });
          }
        })
        .catch((err) => {
          if (err.response?.statusText === "Unauthorized") {
            setLoadingExcel(false);
            dispatch(handleActionLogout());
          } else {
            dispatch({
              type: "FILL_GAGAL",
              gagal: true,
              pesan: err?.response?.data?.message,
            });
            setLoadingExcel(false);
          }
        });
    }
  };

  const fetchDataTable = () => {
    Axios.get(
      urlAPI +
        "/v1/obat/dataObatKronis?params=" +
        JSON.stringify({
          options: {
            page: tableOps?.page,
            limit: tableOps?.limit,
          },
          sbu: filter?.sbu,
          fromdate:
            filter?.fromdate !== null &&
            filter?.fromdate !== "" &&
            filter?.fromdate !== undefined
              ? moment(filter?.fromdate).format("YYYY-MM-DD")
              : null,
          untildate:
            filter?.untildate !== null &&
            filter?.untildate !== "" &&
            filter?.untildate !== undefined
              ? moment(filter?.untildate).format("YYYY-MM-DD")
              : null,
        }),
      {
        headers: {
          Authorization: "Bearer " + getToken(),
        },
      }
    )
      .then((response) => {
        setTableState({
          ...response?.data?.result,
        });
        setLoadingTable(false);
      })
      .catch((err) => {
        if (err.response?.statusText === "Unauthorized") {
          setLoadingTable(false);
          dispatch(handleActionLogout());
        } else {
          dispatch({
            type: "FILL_GAGAL",
            gagal: true,
            pesan: err?.response?.data?.message,
          });
          setLoadingTable(false);
        }
      });
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setTableOps({ ...tableOps, limit: newPerPage, page: 1 });
  };
  const handlePageChange = (page) => {
    setTableOps({ ...tableOps, page: page });
  };

  const columns = [
    {
      name: "NO",
      width: "50px",
      sortable: false,
      cell: (row, index) => index + 1,
      grow: 0,
    },
    {
      name: "NOREG",
      width: "125px",
      sortable: false,
      cell: (row) => row?.NOREG,
    },
    {
      name: "NORM",
      width: "80px",
      sortable: false,
      cell: (row) => row?.NORM,
    },
    {
      name: "NAMA",
      width: "150px",
      sortable: false,
      cell: (row) => row?.NAMA,
    },
    {
      name: "KODE BARANG",
      width: "125px",
      sortable: false,
      cell: (row) => row?.KODEBARANG,
    },
    {
      name: "NAMA BARANG",
      width: "150px",
      sortable: false,
      cell: (row) => row?.NAMABARANG,
    },
    {
      name: "JUMLAH",
      width: "10%",
      sortable: false,
      cell: (row) => (
        <NumberFormat
          value={Number(row?.JUMLAH)}
          displayType={"text"}
          decimalSeparator={","}
          thousandSeparator={"."}
          decimalScale={0}
          fixedDecimalScale={true}
        />
      ),
    },
    {
      name: "HARGA",
      width: "10%",
      sortable: false,
      cell: (row) => (
        <NumberFormat
          value={Number(row?.HRGJUAL)}
          displayType={"text"}
          decimalSeparator={","}
          thousandSeparator={"."}
          decimalScale={0}
          fixedDecimalScale={true}
        />
      ),
    },
    {
      name: "TOTAL",
      width: "150px",
      sortable: false,
      cell: (row) => (
        <>
          {"Rp. "}
          <NumberFormat
            value={Number(row.TOTAL)}
            displayType={"text"}
            decimalSeparator={","}
            thousandSeparator={"."}
            decimalScale={0}
            fixedDecimalScale={true}
          />
        </>
      ),
    },
  ];
  console.log("filter", filter);

  return (
    <>
      <Center>
        <h1>
          <strong>Softcopy Obat Kronis</strong>
        </h1>
      </Center>
      {dataExcel?.rows.length > 0 && !loadingExcel && (
        <ExcelFile
          hideElement={true}
          filename={
            "Softcopy Obat Kronis " +
            filter?.sbu +
            " " +
            filter?.fromdate +
            "-" +
            filter?.untildate
          }
        >
          <ExcelSheet
            data={dataExcel?.rows}
            name={"Softcopy Obat Kronis " + filter?.sbu}
          >
            {Object.keys(dataExcel?.rows[0]).map(function (key, index) {
              return <ExcelColumn label={key} value={key} />;
            })}
          </ExcelSheet>
        </ExcelFile>
      )}

      <Card body>
        {showFilter && (
          <>
            <br />
            <Row>
              <Col lg="6" md="6" sm="12">
                <Center>
                  <img
                    src="/assets/img/Pills-01.svg"
                    className="img-responsive"
                    style={{ width: "60%" }}
                  />
                </Center>
              </Col>

              <Col lg="6" md="6" sm="12">
                <Row>
                  <Col lg="12" md="12" sm="12">
                    <FormGroup>
                      <Label>Pilih SBU</Label>
                      <Select
                        styles={{
                          color: "black",
                          // Fixes the overlapping problem of the component
                          menu: (provided) => ({ ...provided, zIndex: 9999 }),
                        }}
                        id="sbu"
                        name="sbu"
                        options={selectSBU}
                        value={selectSBU?.find(
                          (find) => find.value === filter?.sbu
                        )}
                        onChange={(e) => {
                          setFilter({ ...filter, sbu: e.value });
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col lg="12" md="12" sm="12">
                    <FormGroup>
                      <Label>Tanggal</Label>
                      <Flatpickr
                        value={[filter?.fromdate, filter?.untildate]}
                        className="form-control"
                        options={{ mode: "range" }}
                        onChange={(event) => {
                          setFilter({
                            ...filter,
                            fromdate: event[0],
                            untildate: event[1],
                          });
                        }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col lg="12" md="12" sm="12">
                    <Button
                      className="btn float-right btn-sm"
                      size="sm"
                      block={true}
                      color="primary"
                      onClick={() => {
                        setTableOps({ ...tableOps, page: 1 });
                        setLoadingTable(true);
                        fetchDataTable();
                      }}
                      disabled={
                        filter?.sbu == null ||
                        filter?.fromdate == null ||
                        filter?.untildate == null ||
                        loadingTable
                      }
                    >
                      <Icons.Search size={14} />
                      {loadingTable ? " Loading..." : " Cari Data"}
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col lg="12" md="12" sm="12">
                <Button
                  className="btn float-right"
                  color="success"
                  // outline
                  size="sm"
                  disabled={
                    !tableState?.rows ||
                    tableState?.rows?.length < 1 ||
                    loadingExcel
                  }
                  onClick={() => {
                    fetchDataExcel();
                  }}
                >
                  <Icons.Download size={14} />
                  {loadingExcel ? "Loading..." : "Download Excel"}
                </Button>
              </Col>
            </Row>
            <hr />
          </>
        )}

        <DataTable
          data={tableState?.rows}
          progressPending={loadingTable}
          columns={columns}
          noHeader
          pagination
          paginationServer
          paginationDefaultPage={tableOps?.page}
          paginationPerPage={tableOps?.limit}
          paginationTotalRows={tableState?.count}
          onChangeRowsPerPage={handlePerRowsChange}
          onChangePage={handlePageChange}
        />
      </Card>
    </>
  );
}
